import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

// material-ui
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Theme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import useMediaQuery from "@mui/material/useMediaQuery";

// project imports
import Breadcrumbs from "components/@extended/Breadcrumbs";
import Loader from "components/Loader";
import Drawer from "./Drawer";
import HorizontalBar from "./Drawer/HorizontalBar";
import Footer from "./Footer";
import Header from "./Header";
// import AuthGuard from 'utils/route-guard/AuthGuard';

import { handlerDrawerOpen, useGetMenuMaster } from "api/menu";
import { MenuOrientation } from "config";
import useConfig from "hooks/useConfig";
import navigation from "menu-items";
import { getCurrentNavItem } from "utils/getCurrentNavItem";

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const currentNavItem = getCurrentNavItem(navigation.items, pathname);
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme: Theme) => theme.breakpoints.down("xl"));
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  const { container, miniDrawer, menuOrientation } = useConfig();

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!downXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    // <AuthGuard> /// This change is temporal
    <Box sx={{ display: "flex", width: "100%" }}>
      <Header />
      {!isHorizontal ? <Drawer /> : <HorizontalBar />}

      <Box
        component="main"
        sx={{ width: "calc(100% - 260px)", flexGrow: 1, p: { xs: 2, sm: 3 } }}
      >
        <Toolbar sx={{ mt: isHorizontal ? 8 : "inherit" }} />
        <Container
          maxWidth={container ? "xl" : false}
          sx={{
            ...(container && { px: { xs: 0, sm: 2 } }),
            position: "relative",
            minHeight: "calc(100vh - 110px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {currentNavItem?.breadcrumbs !== false && <Breadcrumbs />}
          <Outlet />
          <Footer />
        </Container>
      </Box>
    </Box>
    // </AuthGuard>
  );
}
